import React from 'react';
import { Progress } from 'antd';
import { Users, CircleCheck, Store, TrendingUp } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';
import { semantic } from '../../../theme/tokens';
import { complianceTone } from './promoterTable.controller';
import { t } from '../../../company/labels';

export default function PromoterAnalytics({ promoters }) {
    const analytics = React.useMemo(() => {
        const totalPromoters = promoters?.length || 0;

        // Count by channel
        const moderno = promoters?.filter((p) => p.channel === 'moderno')?.length || 0;
        const tradicional = promoters?.filter((p) => p.channel === 'tradicional')?.length || 0;

        // Calculate average compliance
        const promotersWithPercentage = promoters?.filter((p) => p.percentage !== undefined && p.percentage !== null) || [];
        const avgCompliance =
            promotersWithPercentage.length > 0
                ? promotersWithPercentage.reduce((sum, p) => sum + (parseFloat(p.percentage) || 0), 0) / promotersWithPercentage.length
                : 0;

        // Count high performers (>= 80%)
        const highPerformers = promoters?.filter((p) => parseFloat(p.percentage) >= 80)?.length || 0;

        return { totalPromoters, moderno, tradicional, avgCompliance, highPerformers };
    }, [promoters]);

    const complianceToneName = complianceTone(analytics.avgCompliance);

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-4">
            <StatCard
                label={`Total ${t('promotores')}`}
                value={formatNumber(analytics.totalPromoters)}
                icon={<Users />}
                tone="brand"
                hint={`${analytics.moderno} moderno · ${analytics.tradicional} tradicional`}
            />
            <StatCard
                label="Cumplimiento Promedio"
                value={`${analytics.avgCompliance.toFixed(1)}%`}
                valueTone={complianceToneName}
                icon={<TrendingUp />}
                tone={complianceToneName}
                hint="Promedio del equipo"
                footer={
                    <Progress
                        percent={analytics.avgCompliance}
                        showInfo={false}
                        strokeColor={semantic[complianceToneName].solid}
                        size={['100%', 6]}
                        className="!m-0"
                    />
                }
            />
            <StatCard
                label="Alto Rendimiento"
                value={formatNumber(analytics.highPerformers)}
                valueTone="success"
                icon={<CircleCheck />}
                tone="success"
                hint="Con ≥80% cumplimiento"
            />
            <StatCard label="Canal Moderno" value={formatNumber(analytics.moderno)} icon={<Store />} tone="info" hint={`${t('promotores')} asignados`} />
        </div>
    );
}
